import type { BannerConfig } from '../types';

export const IMPORT_MODEL_NOT_FOUND: BannerConfig = {
  type: 'danger',
  timeout: 6000,
  title: 'Import model not found',
  description: 'The import model with id could not be found.',
};

export const IMPORT_MODEL_DAMAGED: BannerConfig = {
  type: 'danger',
  timeout: 6000,
  title: 'Failed to open graph model',
  description: 'Import model corrupted. Please try with a new model.',
};

export const IMPORT_MODEL_SAVE_TO_STORAGE_FAILED: BannerConfig = {
  type: 'danger',
  timeout: 6000,
  title: 'Failed to save model',
  description: 'Failed to save model to storage. Check your internet connection.',
};
